module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tz-bec1e1d6b9d5b6bb98b3d19c9b24e698.svg";